import { useEffect } from "react";

const BRAND = "Phoenix Capital Solutions";

/**
 * useDocumentTitle — set the browser tab title for the current screen and
 * restore the previous title on unmount. Shared so every staff/portal page
 * can give the tab a meaningful name (e.g. "Deal status · Phoenix Capital
 * Solutions") instead of one generic title everywhere. Pure (no auth/router).
 */
export function useDocumentTitle(title?: string | null): void {
  useEffect(() => {
    const previous = document.title;
    document.title = title ? `${title} · ${BRAND}` : BRAND;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
